import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonModule } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
} from 'rxjs';
import { SearchQueryOption } from '../interfaces/search.interfaces';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, FormsModule, AngularSvgIconModule, ButtonModule],
})
export class SearchBoxComponent<T = unknown> implements OnDestroy {
  @Input() placeholder: string;

  @Input() keyword = '';

  @Input() filter: T;

  @Input() isAllowedSearchEmpty = false;

  @Input() isAllowedAutoSearch = false;

  @Output() loadEvent = new EventEmitter<SearchQueryOption>();

  @ViewChild(InputText, {
    static: true,
  })
  input: InputText;

  inputMaxLength = 100;

  private readonly keywordChanged: Subject<string> = new Subject<string>();

  private readonly keywordSub: Subscription;

  constructor() {
    this.keywordSub = this.keywordChanged
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((value: string) => {
        this.keyword = value;
        this.emitLoadEvent();
      });
  }

  onKeywordChange(value: string): void {
    if (!this.isAllowedAutoSearch) return;

    this.keywordChanged.next(value);
  }

  emitLoadEvent(): void {
    this.keyword = this.keyword.trim();

    if (!this.keyword.length && !this.isAllowedSearchEmpty) return;

    const { keyword } = this;

    this.loadEvent.emit({
      keyword,
      filter: this.filter,
    });
  }

  ngOnDestroy(): void {
    this.keywordSub.unsubscribe();
  }
}
